import React from 'react';
import { Modal, Button, Alert, Typography, Space, Divider, Spin } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

interface DeleteUserDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName: string;
  userRole?: string;
  loading?: boolean;
  error?: string | null;
  isCurrentUser?: boolean;
}

export const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  open,
  onClose,
  onConfirm,
  userName,
  userRole = 'utilisateur',
  loading = false,
  error = null,
  isCurrentUser = false,
}) => {
  const isAdmin = userRole === 'admin';
  
  return (
    <Modal
      open={open}
      onCancel={!loading ? onClose : undefined}
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
          <span>Confirmer la suppression</span>
        </Space>
      }
      footer={[
        <Button key="cancel" onClick={onClose} disabled={loading}>
          Annuler
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={onConfirm}
          loading={loading}
        >
          {loading ? 'Suppression...' : 'Confirmer la suppression'}
        </Button>,
      ]}
      closable={!loading}
      width={600}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
          />
        )}
        
        <Paragraph>
          Êtes-vous sûr de vouloir supprimer {isCurrentUser ? 'votre compte' : `l'utilisateur "${userName}"`} ?
        </Paragraph>
        
        {isCurrentUser ? (
          <Alert
            message="Attention : Vous êtes sur le point de supprimer votre propre compte."
            description="Cette action est irréversible. Vous serez immédiatement déconnecté et ne pourrez plus accéder à votre compte."
            type="warning"
            showIcon
          />
        ) : isAdmin ? (
          <Alert
            message="Attention : Suppression d'un administrateur"
            description="Cet utilisateur a des privilèges d'administrateur. Assurez-vous que d'autres administrateurs sont disponibles avant de procéder."
            type="warning"
            showIcon
          />
        ) : (
          <Alert
            message="Cette action est irréversible. Toutes les données associées à cet utilisateur seront définitivement supprimées."
            type="info"
            showIcon
          />
        )}
        
        <Divider />
        
        <div>
          <Text type="secondary" italic>
            Pour confirmer, veuillez taper le nom de l'utilisateur ci-dessous :
          </Text>
          
          <div style={{ 
            backgroundColor: '#f0f0f0', 
            padding: '16px', 
            borderRadius: '8px', 
            marginTop: '8px',
            textAlign: 'center',
            fontFamily: 'monospace',
            fontWeight: 'bold',
          }}>
            {userName}
          </div>
        </div>
      </Space>
    </Modal>
  );
};

export default DeleteUserDialog;
